import { type ResultOf, type VariablesOf, graphql } from 'gql.tada';

const FilteredRestaurantsCarouselQuery = graphql(`
  query FilteredRestaurantsCarousel(
    $regionId: Int
    $sort: RestaurantSortTypes
    $sessions: [SessionTypes]
    $dates: [String]
    $features: [RestaurantFilterTypes]
  ) {
    allRestaurants(
      input: {
        status: [LIVE, ON_HOLD]
        regionId: $regionId
        sort: $sort
        features: $features
        prioritiseByAvailability: { forSession: $sessions, onDate: $dates }
      }
      limit: 10
    ) {
      __typename
      id
      menuTitle
      slug
      gallery
      isNew
      rating
      approvedReviewsCount
      regionRanking
      suburb {
        __typename
        id
        menuTitle
      }
      region {
        __typename
        id
        menuTitle
      }
      cuisines(limit: 1) {
        __typename
        edges {
          node {
            __typename
            id
            title
          }
        }
      }
    }
  }
`);

export type QueryVariables = VariablesOf<typeof FilteredRestaurantsCarouselQuery>;
export type QueryResult = ResultOf<typeof FilteredRestaurantsCarouselQuery>;

export default FilteredRestaurantsCarouselQuery;
